import React, { useEffect, useState } from 'react';

import { useAdmins } from '../../../../hooks/admins';
import { useAssignReviewer } from '../../../../order/hooks/quotes';
import AssignReviewerView from './AssignReviewerView';

const AssignReviewer = ({ quote, initiallyOpen, onDone }) => {
  // quote.reviewer is the admin object; the picker and the PUT work in ids
  // (seeding the object sent `reviewer_id: {…}` when confirmed unchanged).
  const [reviewer, setReviewer] = useState(quote?.reviewer?.id ?? quote?.reviewer);
  const { admins } = useAdmins();
  const { assignReviewer, status, error } = useAssignReviewer();

  return (
    <AssignReviewerView
      {...{
        submitting: status === 'loading',
        reviewer,
        setReviewer,
        admins,
        updateItem: () =>
          assignReviewer({ quoteId: quote.id, reviewerId: reviewer }).then(() => onDone?.(), () => {}),
        error,
        initiallyOpen,
      }}
    />
  );
}

export default AssignReviewer;
